import { ICommand } from 'core-ts-types';
import { STCSchedulingConfigModel } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { UpcomingAppointmentsQuery } from '../../queries/upcoming_appointments_query';
import { AppointmentInfoServant } from '../../servants/appointment_info_servant';
import { IAppointmentRequest, IAppointmentRequestCard } from '../../types/appointment_interfaces';

export class AppointmentRequest extends AppointmentInfoServant {
  appointment: IAppointmentRequest;
  appointmentDetails: IAppointmentRequestCard;

  constructor(
    private ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
    private $state: ng.ui.IStateService,
    private prepareAppointmentCampaignRequestCommand: ICommand,
    private loadUpcomingAppointmentsCommand: ICommand,
    private ngStcSchedulingConfigModel: STCSchedulingConfigModel
  ) {
    super();
    if (_4.isNil(this.ngUpcomingAppointmentsQuery.findAppointment(this.$state.params.id))) {
      this.loadUpcomingAppointmentsCommand().then(() => {
        this.appointment = this.ngUpcomingAppointmentsQuery.findAppointment(this.$state.params.id);
        this.appointmentDetails = this.generateAppointmentRequestCardInfo(this.appointment);
      });
    } else {
      this.appointment = this.ngUpcomingAppointmentsQuery.findAppointment(this.$state.params.id);
      this.appointmentDetails = this.generateAppointmentRequestCardInfo(this.appointment);
    }
  }

  scheduleAppointment(): void {
    this.prepareAppointmentCampaignRequestCommand(this.appointment).then(() => {
      const returnState = { state: 'my.myAppointments.upcoming', params: {} };
      if (this.ngStcSchedulingConfigModel.read().v3_student_scheduler_flag) {
        this.$state.go('my.appointment-invitation-results', {
          invitation_id: `${this.appointment.id}`
        });
      } else {
        this.$state.go('my.appointments.available_times', {
          invitationId: this.appointment.id,
          returnState
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointment_request/appointment_request.ts